// extracted by mini-css-extract-plugin
export default {"WorkLeft":"workLeft_WorkLeft__IZNf5"};